export enum PromoCodeUsageFrequency {
  Any = 'any',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}
